import React, { useEffect, useState } from "react";
import {useHistory} from "react-router-dom";
import { Link } from "react-router-dom";
import { Bars } from  'react-loader-spinner'

import DescriptionIcon from '@material-ui/icons/Description';
import AddIcon from '@material-ui/icons/Add'
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card/Card";
import Backdrop from "@material-ui/core/Backdrop";

import {
  MUISortOptions,
  SelectableRows,
} from "mui-datatables";
import moment from "moment";

import {
  apollo_useStyles,
  options_performance_report_ad_kind,
  options_performance_report_totaling_period_kind,
  options_extract_period_kind,
  weekKeys,
} from "../../atom/Apollo_styles";
import {
  options_report_kind,
  options_extract_frequency_kind,
  options_repeat_status,
  options_menu_kind,
} from "../../atom/Apollo_Options";
import {
  reportcreate_path,
  report_detail_path,
  apollo_report_settings_path,
} from "../../atom/Apollo_links";
import { ApolloBreadcrumbs } from "../../atom/Apollo_Breadcrumbs";
import { CustomizedSnackbars } from "../../atom/Apollo_Mesasge";
import { ApolloContext } from "../../atom/Apollo_Context";
import { ApolloExpired } from "../../atom/Apollo_Expired";
import { ApolloAxios } from "../../atom/Apollo_ApiRequest3";
import {
  ApolloMessage,
  setLoadingMessage,
  setErrorMessageTypeAll,
} from "../../atom/Apollo_Mesasge";
import {
  ApolloDataTable,
  STORAGE_KEY,
} from "../../atom/Apollo_DataTable";
import {APOLLO_PAGE_ID} from "../../common/Apollo_LocalStorageSettings";
import {
  RESULT_CODE,
  MSG,
  EXTRACT_PERIOD_KIND,
  EXTRACT_FREQUENCY_KIND,
  SCHEDULE_KIND,
  NUMBER,
  CHECKBOX_STATE,
  COMMA,
  NULL_YEAR,
  DATETIME_SCHEDULED,
  WEEK,
  DAY,
  SELECT_ALL,
  VALID_STATUS,
  INVALID_STATUS,
  ZERO,
} from "../../common/Apollo_CommonConst_Beta";
import { valueToLabel } from "../../common/Apollo_CommonUtil_Beta";
import {
  ReportSetting,
  ReportMenuCampaignKind,
} from "./ReportModel"
import GenericTemplate from "../../templates/GenericTemplate";

/*
    レポート一覧表示
 */
const ReportPage: React.FC = () => {
  // useContext
  const { data: msg, setmsg } = React.useContext(ApolloMessage);
  const { state } = React.useContext(ApolloContext);

  // current
  const accountGroupId = state.current.accountGroupId;
  const accountId = state.current.accountId;

  // style
  const classes = apollo_useStyles();

  // history
  const history = useHistory();

  // useState
  const [progress, setProgress] = useState(true);
  const [reports, setReports] = useState<ReportSetting[]>([]);

  // カラムリスト
  const columns = [
    {
      name: "",
      label: "詳細",
      options: {
          filter: false,
          sort: false,
          customBodyRenderLite: (idx: number) => {
            return (
              <DescriptionIcon
                onClick={() => handleClickReportDetailOpen(reports[idx].reportSettingId)}
                className={classes.link}
                style={{cursor: "pointer"}}
              />
            );
          }
      },
    },
    {
      name: "reportSettingId",
      label: "予約設定ID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "reportName",
      label: "レポート名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountgroupName",
      label: "アカウントグループ名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "reportKind",
      label: "レポート種別",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToLabel(value, options_report_kind)
        }
      }
    },
    {
      name: "menuCampaignKind",
      label: "メニュー",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: ReportMenuCampaignKind[]) => {
          var local_menu_values: number[] = [];
          for (const menu of options_menu_kind) {
            const menuId = menu.value;
            if (value.some(item => item.menuId === menuId) && !local_menu_values.includes(menuId)) {
              local_menu_values.push(menuId);
            }
          }
          if (local_menu_values.length >= options_menu_kind.length) {
            return <React.Fragment>{SELECT_ALL}</React.Fragment>;
          }

          return (
            <React.Fragment>
              {local_menu_values.map((menuId) => (
                <div key={menuId}>{valueToLabel(menuId, options_menu_kind)}</div>
              ))}
            </React.Fragment>
          );
        }
      }
    },
    {
      name: "outputCaseLebel",
      label: "出力粒度",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToLabel(value, options_performance_report_ad_kind)
        }
      }
    },
    {
      name: "aggregationUnit",
      label: "集計単位",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToLabel(value, options_performance_report_totaling_period_kind)
        }
      }
    },
    {
      name: "extractPeriodKind",
      label: "期間指定",
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          const label = valueToLabel(reports[idx].extractPeriodKind, options_extract_period_kind)
          if (reports[idx].extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM) {
            var period = String(reports[idx].period);
            return (
              <Tooltip title={period} placement="bottom-end">
                <div>{label}</div>
              </Tooltip>
            )
          }
          return label
        }
      }
    },
    {
      name: "extractFrequencyKind",
      label: "抽出頻度",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          const label = valueToLabel(value, options_extract_frequency_kind)
          return label ? label : DATETIME_SCHEDULED;
        }
      }
    },
    {
      name: "scheduleKind",
      label: "スケジュール",
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          const { scheduleKind, extractFrequencyKind, extractWeek, extractDay, scheduledAt } = reports[idx];

          if (scheduleKind === SCHEDULE_KIND.REPEAT) {
            if (extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY) {
              const extractWeekJson = extractWeek ? JSON.parse(extractWeek) as number[] : [];
              const extractWeekStr = weekKeys.filter((_, index) => extractWeekJson[index] === CHECKBOX_STATE.CHECKED).join(COMMA);
              return extractWeekStr.length === NUMBER.ONE ? `${extractWeekStr}${WEEK}` : extractWeekStr;
            }
            return `${extractDay}${DAY}`;
          }

          return moment(scheduledAt).format("YYYY/MM/DD HH:mm");
        }
      }
    },
    {
      name: "repeatStatus",
      label: "ステータス",
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          const { repeatStatus, scheduledAt } = reports[idx];
          return repeatStatus ? valueToLabel(repeatStatus, options_repeat_status) : moment(scheduledAt).diff(moment()) > ZERO ? VALID_STATUS : INVALID_STATUS;
        }
      }
    },
    {
      name: "createdBy",
      label: "作成者",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "modifiedAt",
      label: "更新日",
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          var date = "-";
          if (moment(reports[idx].modifiedAt).format("YYYY") !== NULL_YEAR) {
            date = moment(reports[idx].modifiedAt).format("YYYY/MM/DD");
          }
          var datetime = "";
          if (reports[idx].modifiedAt) {
            datetime = String(moment(reports[idx].modifiedAt).format("YYYY/MM/DD HH:mm"));
          }
          return (
            <Tooltip title={datetime} placement="bottom-end">
              <div>
                {date}
              </div>
            </Tooltip>
          )
        }
      }
    },
  ];

  // リストオプション
  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "reportSettingId",
    direction: 'desc',
  })
  const [numberOfRows, setNumberOfRows] = useState(10)
  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.REPORT,
    apolloPageId: APOLLO_PAGE_ID.REPORT_LIST,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
    setTableProps: () => ({ style: { width: "120%" } }),
  }

  useEffect(() => {
    setmsg(setLoadingMessage(msg, true));
    // ApolloAPIとの接続
    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_settings_path}/${accountGroupId}/${accountId}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        if (response.data.result) {
          setPeriod(response.data.result);
        } else {
          setPeriod([]);
        }
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_REPORT_SETTING));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_REPORT_SETTING, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      setmsg(setLoadingMessage(msg, false));
      setProgress(false)
    });
  }, []);

  const setPeriod = (dataList:ReportSetting[]) => {
    const localData = dataList.map((data) => {
      data.period = "-";
      if (moment(data.startAt).format('YYYY') !== NULL_YEAR) {
        data.period = `${moment(data.startAt).format('YYYY/MM/DD')} - ${moment(data.endAt).format('YYYY/MM/DD')}`;
      }
      return data;
    })
    setReports(localData);
  }

  const handleClickReportDetailOpen = (reportSettingId: number) => {
    //画面遷移
    history.push(report_detail_path + reportSettingId)
  }

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80} />
      </Backdrop>

      <ApolloBreadcrumbs bread_no={76} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
        platform={""} />
      <Grid container spacing={0}>
        <Tooltip title="レポート新規作成" placement="bottom">
          <Link to={`${reportcreate_path}`} className={classes.link}>
            <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
              <AddIcon />
            </Fab>
          </Link>
        </Tooltip>
        <Typography variant="caption">
          {"　　※繰り返しレポートの自動停止について"}
          <br />
          {"　　　レポート対象データがない状態で連続で7回出力されると、繰り返しレポートの処理が自動で停止されます。"}
          <br />
          {"　　　再開される場合、「予約レポート詳細」画面より繰り返し処理を再開してください。"}
        </Typography>
      </Grid>
      <Card className={classes.root} square variant="outlined">
        <ApolloDataTable
          title=""
          data={reports ? reports : []}
          columns={columns}
          options={
            {
              ...options,
              textLabels:{
                body: {noMatch: "該当データが存在しません"}
              },
            }
          }
        />
      </Card>
      <CustomizedSnackbars />
    </GenericTemplate>
  );
}

export default ReportPage;
